"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChatMessage;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChatMessageModule = _interopRequireDefault(require("./ChatMessage.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChatMessage(_ref) {
  var _ref$isChannelShown = _ref.isChannelShown,
      isChannelShown = _ref$isChannelShown === void 0 ? false : _ref$isChannelShown,
      _ref$isAuthorShown = _ref.isAuthorShown,
      isAuthorShown = _ref$isAuthorShown === void 0 ? true : _ref$isAuthorShown,
      _ref$isDateShown = _ref.isDateShown,
      isDateShown = _ref$isDateShown === void 0 ? false : _ref$isDateShown,
      message = _ref.message,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ChatMessageModule.default.message, _ChatMessageModule.default[message.channel], className),
    style: style
  }, isChannelShown && /*#__PURE__*/_react.default.createElement("span", {
    className: _ChatMessageModule.default.channel
  }, "[", message.channel, "]"), isAuthorShown && /*#__PURE__*/_react.default.createElement("span", {
    className: _ChatMessageModule.default.author
  }, message.author), isDateShown && /*#__PURE__*/_react.default.createElement("span", {
    className: _ChatMessageModule.default.time
  }, "(", message.sentAt.toLocaleString(), ")"), /*#__PURE__*/_react.default.createElement("span", {
    className: _ChatMessageModule.default.colon
  }, ": "), message.message);
}